import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import useFormFieldValue from '@gef-ui/form-core/hooks/state/useFormFieldValue';

import { FIELDS } from 'features/views/campaignDashboards/order/form';
import { getContactOrdersIds } from 'features/views/campaignDashboards/order/selectors';

import ContactOrder from './ContactOrder';

const OrdersList = ({ campaignId, disabled }) => {
	const agency = useFormFieldValue({ fieldName: FIELDS.agency });
	const contactOrderIds = useSelector(getContactOrdersIds);

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container spacing={2}>
					{!isNilOrEmpty(agency) &&
						contactOrderIds.map((id, i) => (
							<ContactOrder
								key={id}
								campaignId={campaignId}
								contactOrderId={id}
								tabIndex={i}
								disabled={disabled}
							/>
						))}
				</Grid>
			</Grid>
		</Grid>
	);
};

OrdersList.propTypes = {
	campaignId: PropTypes.string,
	disabled: PropTypes.bool,
};

export default OrdersList;
